
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

const PaymentNotFound: React.FC = () => {
  return (
    <Card className="max-w-3xl mx-auto">
      <CardContent className="p-6">
        <div className="text-center py-8">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-red-100 p-3 text-red-500">
              <AlertTriangle className="h-6 w-6" />
            </div>
          </div>
          <h2 className="text-2xl font-semibold mb-2">Product Not Found</h2>
          <p className="text-gray-500 mb-4">
            The requested product could not be found or has been inactivated.
          </p>
          <p className="text-sm text-gray-400">
            Please check the product URL or contact the merchant for assistance.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default PaymentNotFound;
